import type { AxiosInstance } from 'axios'
import { request } from '../client'
import type { TSyncRun, TSyncRunList, TSyncStatus } from '../types/staff'

export interface SyncApi {
  status: () => Promise<TSyncStatus>
  listRuns: (params?: { service?: string; limit?: number; offset?: number }) => Promise<TSyncRunList>
  getRun: (runId: number) => Promise<TSyncRun>
  retryRun: (runId: number) => Promise<TSyncRun>
  trigger: (service: string) => Promise<TSyncRun>
}

export function createSyncApi(api: AxiosInstance): SyncApi {
  const base = '/staff/sync'
  return {
    status: () =>
      request<TSyncStatus>(api, { method: 'GET', url: `${base}/status` }),
    listRuns: (params) =>
      request<TSyncRunList>(api, { method: 'GET', url: `${base}/runs`, params }),
    getRun: (runId) =>
      request<TSyncRun>(api, { method: 'GET', url: `${base}/runs/${runId}` }),
    retryRun: (runId) =>
      request<TSyncRun>(api, { method: 'POST', url: `${base}/runs/${runId}/retry` }),
    trigger: (service) =>
      request<TSyncRun>(api, { method: 'POST', url: `${base}/trigger`, data: { service } }),
  }
}
